(() => {
  const selector = '[data-stinebe-cart-note]';
  let timer;
  let controller;

  const updateStatus = (field, message, state = '') => {
    const statusId = field.getAttribute('aria-describedby')?.split(' ').find((id) => id.endsWith('-status'));
    const status = statusId ? document.getElementById(statusId) : null;
    if (!status) return;

    status.textContent = message;
    status.dataset.state = state;
  };

  const saveNote = async (field) => {
    const note = field.value;
    const savingText = field.dataset.savingText || 'Lagrer kommentar …';
    const savedText = field.dataset.savedText || 'Kommentaren er lagret.';
    const errorText = field.dataset.errorText || 'Kommentaren kunne ikke lagres. Prøv igjen.';

    controller?.abort();
    controller = new AbortController();
    updateStatus(field, savingText, 'saving');

    try {
      const response = await fetch(window.routes?.cart_update_url || '/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({ note }),
        signal: controller.signal,
      });

      const cart = await response.json();
      if (!response.ok || cart?.errors) throw new Error(cart?.errors || 'Cart note update failed');

      updateStatus(field, savedText, 'saved');
      window.setTimeout(() => {
        const statusId = field.getAttribute('aria-describedby')?.split(' ').find((id) => id.endsWith('-status'));
        const status = statusId ? document.getElementById(statusId) : null;
        if (status?.dataset.state === 'saved') status.textContent = '';
      }, 2500);
      return true;
    } catch (error) {
      if (error.name === 'AbortError') return false;
      updateStatus(field, errorText, 'error');
      return false;
    }
  };

  document.addEventListener('input', (event) => {
    const field = event.target.closest(selector);
    if (!field) return;

    window.clearTimeout(timer);
    timer = window.setTimeout(() => saveNote(field), 450);
  });

  document.addEventListener('change', (event) => {
    const field = event.target.closest(selector);
    if (!field) return;

    window.clearTimeout(timer);
    saveNote(field);
  });

  document.addEventListener('click', async (event) => {
    const link = event.target.closest('#cart-notification-button');
    const field = document.querySelector(selector);
    if (!link || !field || !field.value.trim()) return;

    event.preventDefault();
    window.clearTimeout(timer);
    await saveNote(field);
    window.location.assign(link.href);
  });
})();
